import { serverRequest } from './api';

const exportVar = [serverRequest, ];
export default exportVar;
